import { connectedStore } from '../../../store';
import getPages from '../../../site/selectors/pages';

const isCssColorVariableExist = (cssColorVariable) => {
  const store = connectedStore.get();
  const state = store.getState();

  const pages = getPages(state);

  return pages.some(
    (page) => page.usedCustomColors && page.usedCustomColors.includes(cssColorVariable)
  );
};

export default isCssColorVariableExist;
